<style scoped>
tr:nth-child(odd) {
  background: #f6f6f6;
}
</style>

<template>
  <v-layout xs12 column wrap>
    <v-flex xs12>
      <v-data-table
        :headers="headers"
        :items="orders"
        :must-sort="true"
        :loading="loading"
        class="elevation-0"
        hide-actions
        :pagination.sync="pagination"
      >
        <template v-slot:items="{ item: order }">
          <tr>
            <td>
              {{ new Date(order.timestamp).toLocaleDateString("en-GB") }}
              {{ new Date(order.timestamp).toLocaleTimeString("en-GB") }}
            </td>
            <td>{{ order.shopOrderNo }}</td>
            <td>{{ order.customersOrderNo }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Date",
          value: "timestamp"
        },
        {
          text: "Shop Order No.",
          value: "shopOrderNo"
        },
        {
          text: "Customers Order No.",
          value: "customersOrderNo"
        }
      ],
      pagination: {
        sortBy: "timestamp",
        descending: true,
        rowsPerPage: -1
      }
    };
  },
  computed: {
    ...mapGetters("admin", {
      orders: "getOrderMissingResultList"
    }),
    ...mapState("admin", ["loading"])
  },
  mounted() {
    this.$store.dispatch("admin/fetchOrderMissingResultList");
  }
};
</script>
